import { useEffect, useState } from "react";
import { OrderContent } from "../../../components/order/OrderList";
import TransactionTransactionsMenu from "./TransactionTransactionsMenu";
import TransactionsApprovePaymentModal from "../../../components/modal/transactions/TransactionsApprovePaymentModal";
import TransactionsCancelPayoutRequestModal from "../../../components/modal/transactions/TransactionsCancelPayoutRequestModal";

function TransactionTransactionsList({ orders, ogData, callback, loading }) {
  if (loading)
    return (
      <div className="flex w-full items-center justify-center my-4">
        <div className="primaryLoader"></div>
      </div>
    );

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-2 p-1 rounded-md">
        {orders?.map((order, index) => (
          <Order
            key={index}
            order={order}
            og={ogData?.at(index)}
            callback={callback}
          />
        ))}
      </div>
    </div>
  );
}

export default TransactionTransactionsList;

const Order = ({ order, og, callback }) => {
  // const navigate = useNavigate()
  // const location = useLocation()
  const [open, setOpen] = useState(false);
  const [expand, setExpand] = useState(false);
  const [customerDetailModal, setCustomerDetailModal] = useState(false);
  const [menuLoading, setMenuLoading] = useState(false);
  const [modal, setModal] = useState({
    approve: false,
    decline: false,
  });
  const [loading, setLoading] = useState({
    approve: false,
    decline: false,
  });

  // Modals
  const [accountManagerModal, setAccountManagerModal] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (open) {
        setTimeout(() => {
          setOpen(false);
        }, 400);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="w-full flex  justify-between bg-white p-2 lg:p-4 gap-3 rounded-md">
      {/* <TransactionsCancelPayoutRequestModal
        open={modal}
        setOpen={setModal}
        setLoading={setLoading}
        loading={loading}
        callback={callback}
        data={og}
      /> */}
      {/* <CustomerAssignAccountManagerModal
        data={og}
        open={accountManagerModal}
        setOpen={setAccountManagerModal}
        callback={callback}
      />
      <CustomerDetailModal
        open={customerDetailModal}
        setOpen={setCustomerDetailModal}
        data={og}
        callback={callback}
      />
      <CustomerDetailWalletTopUpModals
        open={modal.topup}
        setOpen={(modalState) => setModal({ ...modal, topup: modalState })}
        data={og}
        setLoading={(loadingState) =>
          setLoading({ ...loading, topup: loadingState })
        }
        loading={loading.topup}
      />
      <CustomerDetailWalletDebitModal
        open={modal.debit}
        setOpen={(modalState) => setModal({ ...modal, debit: modalState })}
        data={og}
        setLoading={(loadingState) =>
          setLoading({ ...loading, debit: loadingState })
        }
        loading={loading.debit}
      />
      <CustomerDetailUploadDocModal
        open={modal.upload}
        setOpen={(modalState) => setModal({ ...modal, upload: modalState })}
        data={og}
        setLoading={(loadingState) =>
          setLoading({ ...loading, upload: loadingState })
        }
        loading={loading.upload}
        callback={callback}
      />
      <CustomerDetailBusinessDetailModal
        open={modal.activate}
        setOpen={(modalState) => setModal({ ...modal, activate: modalState })}
        data={og}
        setLoading={(loadingState) =>
          setLoading({ ...loading, activate: loadingState })
        }
        loading={loading.activate}
        callback={callback}
      />
      <CustomerDetailSendEmailModal
        open={modal.send}
        setOpen={(modalState) => setModal({ ...modal, send: modalState })}
        data={og}
        setLoading={(loadingState) =>
          setLoading({ ...loading, send: loadingState })
        }
        loading={loading.send}
        callback={callback}
      /> */}
      <div className="flex flex-col md:flex-row justify-between flex-1">
        {order?.map(({ elements, width }, index) => (
          <div
            className={`w-full rounded-lg ${width || "flex-1"} ${
              !expand && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              expand && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            {elements?.map((element, idx) => (
              <OrderContent element={element} key={idx} order={og} />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${
          //   bookingData?.status || og?.status ? "flex" : "hidden"
          ""
        } flex flex-col justify-between items-center `}
      >
        <button
          className="cursor-pointer p-2 relative "
          disabled={menuLoading}
          onClick={() => setOpen(true)}
        >
          {menuLoading ? (
            <div className="primaryLoader"></div>
          ) : (
            <img
              src="/IconMore.svg"
              alt=""
              className="h-5 object-contain relative"
            />
          )}
          {/* {open && (
            <TransactionTransactionsMenu
              order={og}
              setApprove={(approve) => {
                setModal({ ...modal, approve: approve });
              }}
              setDecline={(decline) => {
                setModal({ ...modal, decline: decline });
              }}
            />
          )} */}
        </button>
        <button
          className="flex lg:hidden"
          onClick={() => {
            setExpand(!expand);
          }}
        >
          <img
            src="/IconChevronDown.svg"
            alt=""
            className={`w-5 object-contain transition-all ${
              expand ? "rotate-180" : ""
            }`}
          />
        </button>
      </div>
    </div>
  );
};
